import PropTypes from 'prop-types';
import { useState } from 'react';
import styled from 'styled-components';
import FormattedMessage from 'I18n/components/FormattedMessage';
import H4 from 'UIComponents/elements/headings/H4';
import UIBreadcrumbs from 'UIComponents/nav/UIBreadcrumbs';
import UIFlex from 'UIComponents/layout/UIFlex';
import UIButton from 'UIComponents/button/UIButton';
import UILink from 'UIComponents/link/UILink';
import { KeyTypes } from '../constants/popover';
import requiredBy from '../utils/requiredBy';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = suffix => `RichTextLib.morphing.${suffix}`;
const MorphButton = styled(UIButton).withConfig({
  displayName: "MorphingPopoverBody__MorphButton",
  componentId: "sc-17we55y-0"
})(["padding-right:0 !important;"]);
const propTypes = {
  title: PropTypes.string.isRequired,
  titleClassName: PropTypes.string,
  children: PropTypes.node.isRequired,
  morphButtonTitle: PropTypes.string,
  morphedContentTitle: requiredBy('morphButtonTitle', PropTypes.string),
  renderMorphedContent: requiredBy('morphButtonTitle', PropTypes.func)
};
function MorphingPopoverBody(props) {
  const {
    title,
    titleClassName,
    morphButtonTitle,
    morphedContentTitle,
    renderMorphedContent,
    children
  } = props;
  const [showMorphedContent, setShowMorphedContent] = useState(false);
  if (showMorphedContent) {
    const handleCloseMorphedContent = () => {
      setShowMorphedContent(false);
    };
    const handleCloseOnEscape = evt => {
      if (evt.key === KeyTypes.ESCAPE) {
        handleCloseMorphedContent();
      }
    };
    const className = titleClassName ? `${titleClassName} m-bottom-2` : 'm-bottom-2';
    return /*#__PURE__*/_jsxs("div", {
      "data-test-id": "morphed-content",
      onKeyDown: handleCloseOnEscape,
      tabIndex: -1,
      children: [/*#__PURE__*/_jsxs(UIFlex, {
        className: className,
        direction: "column",
        children: [/*#__PURE__*/_jsx(UIBreadcrumbs, {
          className: "m-top-0",
          flush: true,
          children: /*#__PURE__*/_jsx(UILink, {
            "data-test-id": "morphed-content-back-button",
            onClick: handleCloseMorphedContent,
            onMouseDown: evt => evt.preventDefault(),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: i18nKey('back')
            })
          })
        }), /*#__PURE__*/_jsx(H4, {
          className: "m-bottom-0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: morphedContentTitle
          })
        })]
      }), renderMorphedContent({
        onCloseMorphedContent: handleCloseMorphedContent
      })]
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      className: titleClassName || '',
      align: "baseline",
      justify: "between",
      children: [/*#__PURE__*/_jsx(H4, {
        className: "m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: title
        })
      }), morphButtonTitle && /*#__PURE__*/_jsx(MorphButton, {
        "data-test-id": "morph-content-button",
        use: "transparent",
        onClick: () => setShowMorphedContent(true),
        onMouseDown: evt => evt.preventDefault(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: morphButtonTitle
        })
      })]
    }), children]
  });
}
MorphingPopoverBody.propTypes = propTypes;
MorphingPopoverBody.displayName = 'MorphingPopoverBody';
export default MorphingPopoverBody;